import { getAuth } from 'firebase/auth';

const signOut = () => Promise.all([caches?.delete('cards'), getAuth().signOut()]).catch(() => window.location.reload());

export default signOut;
